import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { OrderEditDialog } from '../dialogs/OrderEditDialog'
import { OrderDetailDialog } from '../dialogs/OrderDetailDialog'
import { useTranslation } from 'react-i18next'
import { Client } from '../../redux/reducers/clients'
import { newThemeObject } from '../../newTheme'
import { tokens } from '../../styles/tokens'
import { useCardHeaderStyles } from '../../styles/cards'

const useStyles = makeStyles(theme => ({
  tableWrapper: {
    padding: '16px',
    backgroundColor: tokens.color.white,
    boxShadow: tokens.shadow.sm,
    borderRadius: newThemeObject.roundness.basic,
    overflow: 'hidden',
  },
  tableContent: {
    border: 'none',
    padding: '6px 16px',
  },
  tableText: {
    color: tokens.color.neutral[900],
    margin: 0,
    fontSize: '0.8125rem',
    fontWeight: 500,
  },
  numberBadge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '22px',
    height: '22px',
    borderRadius: tokens.radius.md,
    backgroundColor: tokens.color.primary[100],
    color: tokens.color.primary[800],
    fontSize: '0.6875rem',
    fontWeight: 600,
    flexShrink: 0,
  },
  numAndText: {
    display: 'grid',
    gridTemplateColumns: '22px 1fr',
    alignItems: 'center',
    gap: '10px',
  },
}))

interface Props {
  client: Client
}

export const IvestmentTable: React.FC<Props> = ({ client }) => {
  const classes = useStyles()
  const cardHeader = useCardHeaderStyles()
  const { t } = useTranslation()

  return (
    <>
      <TableContainer component={Paper} className={classes.tableWrapper} elevation={0}>
        <div className={cardHeader.header}>
          <p className={cardHeader.title}>{t('INVESTMENT_RESULT')}</p>
        </div>
        <Table size="small">
          <TableBody>
            <TableRow className="" key="1">
              <TableCell className={classes.tableContent} component="th" scope="row">
                <span className={classes.numAndText}>
                  <span className={classes.numberBadge}>1</span>
                  <p className={classes.tableText}>{t('CLIENT_CATEGORY')}</p>
                </span>
              </TableCell>
              <TableCell className={classes.tableContent} component="th" scope="row">
                <p className={classes.tableText}>{t(client.category || '')}</p>
              </TableCell>
            </TableRow>

            <TableRow className="" key="2">
              <TableCell className={classes.tableContent} component="th" scope="row">
                <span className={classes.numAndText}>
                  <span className={classes.numberBadge}>2</span>
                  <p className={classes.tableText}>{t('KONWLEDGE_AND_EXPERIENCE')}</p>
                </span>
              </TableCell>
              <TableCell className={classes.tableContent} component="th" scope="row">
                <p className={classes.tableText}>{t(client.skillAndExperience || '')}</p>
              </TableCell>
            </TableRow>

            <TableRow className="" key="3">
              <TableCell className={classes.tableContent} component="th" scope="row">
                <span className={classes.numAndText}>
                  <span className={classes.numberBadge}>3</span>
                  <p className={classes.tableText}>{t('INVESTMENT_HORIZONTE')}</p>
                </span>
              </TableCell>
              <TableCell className={classes.tableContent} component="th" scope="row">
                <p className={classes.tableText}>{t(client.investmentHorizonte || '')}</p>
              </TableCell>
            </TableRow>

            <TableRow className="" key="4">
              <TableCell className={classes.tableContent} component="th" scope="row">
                <span className={classes.numAndText}>
                  <span className={classes.numberBadge}>4</span>
                  <p className={classes.tableText}>{t('INTESTMENT_TERGET')}</p>
                </span>
              </TableCell>
              <TableCell className={classes.tableContent} component="th" scope="row">
                <p className={classes.tableText}>{t(client.preference || '')}</p>
              </TableCell>
            </TableRow>

            <TableRow className="" key="5">
              <TableCell className={classes.tableContent} component="th" scope="row">
                <span className={classes.numAndText}>
                  <span className={classes.numberBadge}>5</span>
                  <p className={classes.tableText}>{t('RISK_APPROVE')}</p>
                </span>
              </TableCell>
              <TableCell className={classes.tableContent} component="th" scope="row">
                <p className={classes.tableText}>{t(client.lossAbility || '')}</p>
              </TableCell>
            </TableRow>

            <TableRow className="" key="6">
              <TableCell className={classes.tableContent} component="th" scope="row">
                <span className={classes.numAndText}>
                  <span className={classes.numberBadge}>6</span>
                  <p className={classes.tableText}>{t('RISK_TOLERANT')}</p>
                </span>
              </TableCell>
              <TableCell className={classes.tableContent} component="th" scope="row">
                <p className={classes.tableText}>{client.riskProfile}</p>
              </TableCell>
            </TableRow>

            <TableRow className="" key="7">
              <TableCell className={classes.tableContent} component="th" scope="row">
                <span className={classes.numAndText}>
                  <span className={classes.numberBadge}>7</span>
                  <p className={classes.tableText}>{t('ESG')}</p>
                </span>
              </TableCell>
              <TableCell className={classes.tableContent} component="th" scope="row">
                <p className={classes.tableText}>{t(client.esg || '-')}</p>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <OrderEditDialog />
      <OrderDetailDialog />
    </>
  )
}
